import { Tabs } from "antd"
import { getTranslated } from "../../utils/CommonUtils";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import OxeInfo from "./OxeInfo";
import OxeLog from "./OxeLog";
import OxeConfig from "./OxeConfig";
import TabExtraContent from "../common/TabExtraContent";
import { setContentLoading, setDateFilter, setFieldFilter, setFilter, setSortType, setSortField } from "../../store/reducers/CommonReducer";
import { getOxeOPList } from "../../store/actions/OxeActions";
import OxeUmcParameters from "./OxeUmcParameter";
import { sendGTMEvent } from "../../utils/GTMUtils";

const OxeData = () => {

    const dict = useSelector((state) => state.common.dict)
    const [selectedTab, setSelectedTab] = useState("OXE_information")

    const switchToTab = (key) => {
        setSelectedTab(key)
    }

    const dispatch = useDispatch()

    const items = [
        {
            key: 'OXE_information',
            label: getTranslated(dict, "LABEL_INFO"),
            children: <OxeInfo />
        },
        {
            key: 'OXE_parameters',
            label: getTranslated(dict, "LABEL_OXE_PARAMETERS"),
            children: <OxeConfig switchToTab={switchToTab}/>
        },
        {
            key: 'UMC_parameters',
            label: getTranslated(dict, "LABEL_UMC_PARAMETERS"),
            children: <OxeUmcParameters />,
        },
        {
            key: 'Logs',
            label: getTranslated(dict, "LABEL_LOGS"),
            children: <OxeLog />,
            extraContent: ['refresh']
        }
    ]

    useEffect(() => {
        sendGTMEvent({
            event: "umc_tab_selection",
            selected_item: selectedTab
        })
    }, [selectedTab])

    const onChange = (key) => {
        setSelectedTab(key)
    }

    function handleRefresh() {
        dispatch(setContentLoading(true))

        if (selectedTab === "Logs") {
            dispatch(setDateFilter(""))
            dispatch(setFieldFilter(""))
            dispatch(setSortType(""))
            dispatch(setSortField(""))
            dispatch(setFilter(""))
            dispatch(getOxeOPList())
        }
    }

    
    return <Tabs
        type="card"
        className="tab-common"
        destroyInactiveTabPane={true}
        activeKey={selectedTab}
        tabBarExtraContent={<TabExtraContent
            handleRefresh={handleRefresh}
            selectedTab={selectedTab}
            items={items}
        />}
        items={items}
        onChange={(key) => (key !== selectedTab) && onChange(key)}
        animated={{ inkBar: true, tabPane: true }}
    />
}

export default OxeData